import { actionCreators as photoAlbumActions } from 'react/api/actions/photoAlbum';
import { actionCreators as bulkDownloadActions } from 'react/api/actions/bulkDownload';
import { actionCreators as actionsModals } from 'react/api/actions/modals'; // Adjust the path as necessary

import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

import BulkDownloadService from 'react/services/bulkDownload.service';

export const hasDeletePermission = () => {
  const { permissions } = Monet.Session.Security;

  if (!permissions) return false;

  const hasPermission = permissions?.some((e) => e.key === 'PHOTO_REMOVE');

  return hasPermission;
};

export const convertImageToBinary = (fileBase64) => {
  if (!fileBase64) {
    return new Uint8Array(new ArrayBuffer(0));
  }
  const BASE64_MARKER = ';base64,';
  const base64Index = fileBase64.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
  const base64 = fileBase64.substring(base64Index);
  const raw = atob(base64);
  const rawLength = raw.length;
  const array = new Uint8Array(new ArrayBuffer(rawLength));
  for (let i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }
  return array;
};

export const getLiveAlbumId = (albums) => {
  const userId = Monet.Session.User.id;

  const liveAlbum = albums.find((item) => {
    if (item.key?.includes('LIVE') && item.user?.id === userId) {
      return item;
    }
  });

  if (!liveAlbum) return null;

  return liveAlbum.id;
};

export const downloadPhotos = async (data) => {
  const totalFiles = data?.payload?.length;
  const response = await defaultFetch('/photoDownload', data, 'POST', false);

  if (response.error) {
    console.log('Failed download photos');

    return;
  }

  GreenmileReduxStore.dispatch(photoAlbumActions.clear());
  GreenmileReduxStore.dispatch(
    bulkDownloadActions.createTmpDownload({
      totalFiles
    })
  );
  GreenmileReduxStore.dispatch(
    actionsModals.closeModal({ modalKey: 'photoAlbum' })
  );
};

export const startBulkDownloadService = () => {
  const getTimeoutInstance = (eventSource) => {
    const FIVE_MINUTES = 1000 * 60 * 5;

    return setTimeout(() => {
      if (eventSource) {
        console.log('Closing event source');

        eventSource.close();
        Monet.Session.BulkDownloadService = null;
      }
    }, FIVE_MINUTES);
  };

  if (Monet.Session.BulkDownloadService) {
    console.log('BulkDownloadService already started');

    clearTimeout(Monet.Session.BulkDownloadService.timeout);

    Monet.Session.BulkDownloadService.timeout = getTimeoutInstance(
      Monet.Session.BulkDownloadService.eventSource
    );

    return;
  }

  const userlogin = Monet.Session.User.login;
  const downloadService = new BulkDownloadService(userlogin);
  downloadService.connect();

  Monet.Session.BulkDownloadService = {
    eventSource: downloadService.eventSource,
    timeout: getTimeoutInstance(downloadService.eventSource)
  };

  return downloadService;
};

export const downloadSelectedPhotos = (
  selectedAlbums,
  setStateLoading
) => {
  const tenant = Greenmile.Utils.getTenant();
  const { login: username } = Monet.Session.User;

  startBulkDownloadService();

  const allPhotos = Object.values(selectedAlbums).flatMap((album) => album);

  const payload = allPhotos
    .map(({ base64Thumbnail, filePath, id }) => ({
      base64Thumbnail,
      filePath,
      id
    }));

  const data = {
    tenant,
    username,
    status: 'START',
    payload
  };

  setStateLoading(true);

  downloadPhotos(data).finally(() => {
    setStateLoading(false);
  });
};
